import { Button, Col, Row } from "components/styleguide";
import UserGuide from "components/UserGuide";
import { toNumber } from "lodash";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

import ConferenceTimingsDrawer from "./components/ConferenceTimingsDrawer/ConferenceTimingsDrawer";

const ConferenceTimings = () => {
  const { t } = useTranslation();
  const [uploadTimingDrawerVisible, setUploadTimingDrawerVisible] = useState(false);

  const forumId = toNumber(useParams().id);

  const showUploadTimingDrawer = (): void => {
    setUploadTimingDrawerVisible(true);
  };

  const hideUploadTimingDrawer = (): void => {
    setUploadTimingDrawerVisible(false);
  };

  return (
    <div className="table-wrapper">
      <ConferenceTimingsDrawer forumId={forumId} visible={uploadTimingDrawerVisible} onClose={hideUploadTimingDrawer} />
      <Row gutter={[24, 16]}>
        <Col span={24}>
          {/* TODO UPDATE articleId with the right one */}
          <UserGuide.Title title="Conference Timings" articleId="conference-timings" />
        </Col>
        <Col span={24}>
          <Button onClick={showUploadTimingDrawer}>{t("Upload Timings")}</Button>
        </Col>
      </Row>
    </div>
  );
};

export default ConferenceTimings;
